import { render } from "./TheTinhTrangTruDen.vue?vue&type=template&id=7ee58f35"
import script from "./TheTinhTrangTruDen.vue?vue&type=script&lang=js"
export * from "./TheTinhTrangTruDen.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__